<div class="relative inline-block w-full">
    <div *ngIf="mode === 'determinate'" class="progress-bar-wrapper flex gap-1 items-center">
        <mat-progress-bar
            [value]="progress"
            [mode]="mode"
            color="accent"
            class="w-full h-1 rounded-full"
        ></mat-progress-bar>
        <!-- force it to be inside of the circle -->
        <span class="progress-bar-label">{{ progress }}%</span>
    </div>

    <div class="progress-bar-wrapper" *ngIf="mode === 'indeterminate'">
        <mat-progress-bar [mode]="mode" color="accent" class="w-full h-1 rounded-full"></mat-progress-bar>
    </div>
</div>
